import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
const NotificationsListSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Skeleton className="h-16 rounded-md" /><Skeleton className="h-16 rounded-md" /><Skeleton className="h-16 rounded-md" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default NotificationsListSkeleton;